"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var changeCase_1 = require("../../utils/changeCase");
var BaseTransform_1 = require("./BaseTransform");
var CaseTransform = /** @class */ (function (_super) {
    __extends(CaseTransform, _super);
    function CaseTransform() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CaseTransform.prototype.execute = function (queryResponse, queryOptions, executionOptions) {
        var response = queryResponse;
        var caseType = this.options.caseType;
        if (queryResponse && caseType) {
            response = queryResponse.toString();
            switch (caseType) {
                case 'camel':
                    response = changeCase_1.camelCase(response);
                    break;
                case 'lower':
                    response = changeCase_1.lowerCase(response);
                    break;
                case 'param':
                    response = changeCase_1.paramCase(response);
                    break;
                case 'pascal':
                    response = changeCase_1.pascalCase(response);
                    break;
                case 'title':
                    response = changeCase_1.titleCase(response);
                    break;
                case 'upper':
                    response = changeCase_1.upperCase(response);
                    break;
                case 'snake':
                    response = changeCase_1.snakeCase(response);
                    break;
                default:
                    break;
            }
        }
        return response;
    };
    return CaseTransform;
}(BaseTransform_1.BaseTransform));
exports.CaseTransform = CaseTransform;
//# sourceMappingURL=CaseTransform.js.map